/**
 * Enumé — Color Tokens
 * SOURCE OF TRUTH FOR NON-ZONE COLOR.
 *
 * This file is imported by:
 *   - tailwind.config.js  → generates `type-*` utilities and :root variables
 *   - src/config/zones.js → for TYPE_COLORS and UNZONED_COLOR
 *
 * It has ZERO imports on purpose. tailwind.config.js is evaluated by Node on
 * every rebuild, so this file must stay cheap to load — and, as of August
 * 2026, must stay loadable by plain Node. Do not import zones_dictionary.js,
 * zones.config.json, or anything else into it.
 *
 * ─────────────────────────────────────────────────────────────────────────
 * WHERE ZONE_COLORS WENT (August 2026)
 * ─────────────────────────────────────────────────────────────────────────
 * ZONE_COLORS used to be a literal map here, duplicated again in
 * backend/app/zone_config.py, with a third hardcoded list of the same ids in
 * tailwind.config.js, and `npm run check:tokens` policing the copies.
 *
 * All of it now derives from ONE file: backend/zones.config.json.
 *
 *   - Need zone hexes in app code?  import { ZONE_COLORS } from './zones.js'
 *   - Tailwind reads the JSON directly with fs (see tailwind.config.js).
 *
 * It is exported from zones.js rather than here because a bare JSON import
 * throws ERR_IMPORT_ATTRIBUTE_MISSING under plain Node, and this file sits in
 * Node's load path. zones.js only ever runs through Vite, where JSON imports
 * are native.
 *
 * WHY THE CONFIG LIVES UNDER backend/: the backend deploy artifact contains
 * backend/ and nothing above it. A repo-root config would be missing from the
 * App Service package and zone_config.py would fail at import — a dead site,
 * discovered in production. From backend/, both deploys get it: the Flask
 * package includes it directly, and Vite inlines it into the frontend bundle
 * at build time, so a wrong path fails the CI build rather than the running
 * site.
 *
 * Anything Tailwind already ships (zinc, purple, indigo…) is NOT redeclared
 * here. The plugin in tailwind.config.js derives those CSS variables from
 * Tailwind's own palette, so there is nothing to keep in sync.
 * ─────────────────────────────────────────────────────────────────────────
 */

/** Project type ring colors on the cosmic map. */
export const TYPE_COLORS = {
  physical: '#10b981', // emerald
  digital:  '#8b5cf6', // violet
  hybrid:   '#f59e0b', // amber
};

/** Node fallback for projects with no resolved zone. */
export const UNZONED_COLOR = '#71717a'; // zinc-500

/** Semantic app colors. Values that intentionally differ from Tailwind's
 *  named palette live here; everything else is derived in the config. */
export const SEMANTIC_COLORS = {
  primary:      '#8b5cf6', // violet-500 — NOT purple-500
  primaryHover: '#7c3aed', // violet-600
};

export default { TYPE_COLORS, UNZONED_COLOR, SEMANTIC_COLORS };